// extracted by mini-css-extract-plugin
export default {"product_card":"ProductCard_product_card__VWe-a"};